export const sm = (name = '', value = '') => ({ target: { name, value } })
